(function () {
  if (window.__nubeAutumn) return;
  window.__nubeAutumn = true;

  var EYEBROW = 'Enjoy our autumn prices';
  var CART_TEXT = 'Autumn prices end soon';

  var style = document.createElement('style');
  style.textContent =
    '.nube-tiers .nube-tiers__eyebrow{font-size:.6875rem;letter-spacing:.1em}' +
    '.nube-eyebrow-autumn{color:#8a3b2f}' +
    '.nube-eyebrow-autumn::before{content:"·";margin-inline:.6em;color:#4a5a28}' +
    '.cart-items__table .nube-pack__autumn{display:block;margin-top:2px;font-size:.75rem;font-weight:500;color:#8a3b2f}';
  document.head.appendChild(style);

  function decorateEyebrows() {
    document.querySelectorAll('.nube-tiers__eyebrow').forEach(function (eyebrow) {
      var first = eyebrow.firstChild;
      if (first && first.nodeType === 3) {
        var t = first.textContent;
        [' - ', ' – ', ' — '].forEach(function (d) {
          if (t.indexOf(d) !== -1) t = t.split(d).join(' ');
        });
        if (t !== first.textContent) first.textContent = t;
      }
      if (!eyebrow.querySelector('.nube-eyebrow-autumn')) {
        var note = document.createElement('span');
        note.className = 'nube-eyebrow-autumn';
        note.textContent = EYEBROW;
        eyebrow.appendChild(note);
      }
    });
  }

  function decorateCart() {
    document.querySelectorAll('.cart-items__table-row').forEach(function (row) {
      if (row.classList.contains('nube-pack-line')) return;
      var cell = row.querySelector('.cart-items__price');
      if (!cell || cell.querySelector('.nube-pack__autumn')) return;
      if (!row.querySelector('s.compare-at-price')) return;
      var note = document.createElement('span');
      note.className = 'nube-pack__autumn';
      note.textContent = CART_TEXT;
      cell.appendChild(note);
    });
  }

  var decorating = false;
  var scheduled = false;
  function run() {
    scheduled = false;
    decorating = true;
    try {
      decorateEyebrows();
      decorateCart();
    } finally {
      decorating = false;
    }
  }
  function schedule() {
    if (decorating || scheduled) return;
    scheduled = true;
    requestAnimationFrame(run);
  }
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  run();

  /* Couleur choisie -> image correspondante. Le sélecteur du haut (1-1) est géré par le bloc nube-buy-selector. */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('[data-nube-tier-unit]')) return;
    if (!input.closest('.nube-tiers__swatch')) return;
    var unit = input.getAttribute('data-nube-tier-unit') || '';
    if (unit === '1-1' || unit.indexOf('acc') === 0) return;
    var map = window.__nubeColourMedia || {};
    if (!Object.prototype.hasOwnProperty.call(map, input.value)) return;
    var gallery = document.querySelector('media-gallery');
    if (gallery && gallery.slideshow && typeof gallery.slideshow.select === 'function') {
      gallery.slideshow.select(map[input.value], undefined, { animate: false });
    }
  });
})();